import {
  Badge,
  Divider,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaChartBar, FaChevronDown } from "react-icons/fa";

export default function ReportTypeSelector({
  availableReports,
  getAdvancedReportInfo,
  getReportList,
  isRTL,
  onChange,
  reportsLoading,
  selectedReport,
  t,
}) {
  const activeReport = selectedReport ? getAdvancedReportInfo(selectedReport) : null;

  return (
    <Menu>
      <MenuButton w="full" variant="outline" size="sm" textAlign={isRTL ? "right" : "left"}>
        <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
          {isRTL && <Icon as={FaChevronDown} />}
          {reportsLoading && <Spinner size="xs" />}
          <HStack spacing={1} flex={1} minW={0} justify={isRTL ? "flex-end" : "flex-start"}>
            {activeReport ? (
              <>
                <Text noOfLines={1} flex={1}>{activeReport.name}</Text>
                <Icon as={activeReport.icon} color={`${activeReport.color}.500`} />
                {activeReport.requiresAdditionalData && (
                  <Badge colorScheme="orange" variant="solid" size="sm">
                    {t("reports.required", "مطلوب")}
                  </Badge>
                )}
              </>
            ) : (
              <Text noOfLines={1} flex={1}>
                {t("reports.selectReport", "اختر نوع التقرير")}
              </Text>
            )}
          </HStack>
          {!isRTL && <Icon as={FaChevronDown} />}
        </HStack>
      </MenuButton>
      <MenuList maxH="300px" overflowY="auto" minW="350px">
        {reportsLoading ? (
          <MenuItem textAlign="center">
            <HStack spacing={2}>
              <Spinner size="sm" />
              <Text>{t("reports.loadingReports", isRTL ? "جاري تحميل التقارير..." : "Loading reports...")}</Text>
            </HStack>
          </MenuItem>
        ) : (
          <>
            {availableReports.aiAnalysis.length > 0 && (
              <>
                <HStack px={3} py={2} spacing={1}>
                  <Icon as={FaChartBar} color="blue.600" boxSize={3} />
                  <Text fontSize="xs" fontWeight="bold" color="blue.600">
                    {t("reports.aiReports", isRTL ? "تقارير الذكاء الاصطناعي" : "AI Reports")} ({availableReports.aiAnalysis.length})
                  </Text>
                </HStack>
                {availableReports.aiAnalysis.map((report) => {
                  const reportInfo = getAdvancedReportInfo(report.ReportKey);

                  return (
                    <MenuItem key={report.ReportKey} onClick={() => onChange(report.ReportKey)}>
                      <HStack spacing={1} w="full">
                        <VStack align={isRTL ? "end" : "start"} spacing={0} flex={1}>
                          <Text fontWeight="medium">{reportInfo.name}</Text>
                          <Text fontSize="xs" color="gray.500">{report.ProviderKey}</Text>
                        </VStack>
                        <Icon as={reportInfo.icon} color={`${reportInfo.color}.500`} />
                        {report.AllowedModels && (
                          <Badge colorScheme="green" variant="subtle" size="xs">AI</Badge>
                        )}
                      </HStack>
                    </MenuItem>
                  );
                })}
                <Divider my={1} />
              </>
            )}

            {getReportList.length === 0 ? (
              <MenuItem textAlign="center" isDisabled>
                <Text color="gray.500">
                  {t("reports.noReportsAvailable", isRTL ? "لا توجد تقارير متاحة" : "No reports available")}
                </Text>
              </MenuItem>
            ) : (
              getReportList.map((reportKey) => {
                if (availableReports.aiAnalysis.some((item) => item.ReportKey === reportKey)) {
                  return null;
                }

                const reportInfo = getAdvancedReportInfo(reportKey);
                return (
                  <MenuItem key={reportKey} onClick={() => onChange(reportKey)}>
                    <HStack spacing={1} w="full">
                      <Text fontWeight="medium" flex={1}>{reportInfo.name}</Text>
                      <Icon as={reportInfo.icon} color={`${reportInfo.color}.500`} />
                      {reportInfo.requiresAdditionalData && (
                        <Badge colorScheme="orange" variant="subtle" size="sm">
                          {t("reports.required", "مطلوب")}
                        </Badge>
                      )}
                    </HStack>
                  </MenuItem>
                );
              })
            )}
          </>
        )}
      </MenuList>
    </Menu>
  );
}
